import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/administration/organizations/$orgId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspace/organizations/$orgId",
      params: { orgId: params.orgId },
    });
  },
});
